(function () {
  'use strict';

  if (window.UnifiedPageContext) {
    return;
  }

  const VERSION = '1.0.0';

  function normalizePath() {
    const path = String(
      window.location && window.location.pathname
        ? window.location.pathname
        : '/'
    ).toLowerCase();

    if (!path) return '/';
    return path.length > 1 ? path.replace(/\/+$/, '') : path;
  }

  function getRuntime() {
    return window.UnifiedPageRuntime || {};
  }

  function classify(path) {
    if (path === '/') {
      return { page_type: 'home', page_subtype: '', journey_area: 'discovery' };
    }

    if (path.startsWith('/products/')) {
      return { page_type: 'product', page_subtype: '', journey_area: 'commerce' };
    }

    if (path === '/collections' || path.startsWith('/collections/')) {
      return { page_type: 'collection', page_subtype: '', journey_area: 'commerce' };
    }

    if (path === '/cart') {
      return { page_type: 'cart', page_subtype: '', journey_area: 'commerce' };
    }

    if (path === '/search' || path.startsWith('/search/')) {
      return { page_type: 'search', page_subtype: '', journey_area: 'discovery' };
    }

    if (path === '/blogs' || /^\/blogs\/[^/]+$/.test(path)) {
      return { page_type: 'blog', page_subtype: '', journey_area: 'editorial' };
    }

    if (/^\/blogs\/[^/]+\/[^/]+/.test(path)) {
      return { page_type: 'article', page_subtype: '', journey_area: 'editorial' };
    }

    if (path === '/pages/somelier-virtual') {
      return { page_type: 'page', page_subtype: 'somelier', journey_area: 'discovery' };
    }

    if (
      path === '/pages/vin-cutie-6' ||
      path === '/pages/cutia-de-6' ||
      path.includes('cutie-personaliz')
    ) {
      return { page_type: 'page', page_subtype: 'bundle', journey_area: 'commerce' };
    }

    if (path === '/account' || path.startsWith('/account/')) {
      return { page_type: 'account', page_subtype: '', journey_area: 'utility' };
    }

    if (path.startsWith('/pages/')) {
      return { page_type: 'page', page_subtype: '', journey_area: 'discovery' };
    }

    return { page_type: 'other', page_subtype: '', journey_area: 'utility' };
  }

  function buildTemplateName(runtime) {
    const name = String(runtime.templateName || '').trim().toLowerCase();
    const suffix = String(runtime.templateSuffix || '').trim().toLowerCase();

    if (!name) return '';
    return suffix ? name + '.' + suffix : name;
  }

  function getContext() {
    const path = normalizePath();
    const runtime = getRuntime();
    const classification = classify(path);

    return {
      page_type: classification.page_type,
      page_subtype: classification.page_subtype,
      journey_area: classification.journey_area,
      template_name: buildTemplateName(runtime),
      product_handle: String(runtime.productHandle || '').trim().toLowerCase(),
      collection_handle: String(runtime.collectionHandle || '').trim().toLowerCase(),
      article_handle: String(runtime.articleHandle || '').trim().toLowerCase()
    };
  }

  window.UnifiedPageContext = {
    version: VERSION,
    getContext: getContext
  };
})();
